export const PALETTE = [
  ['#FF6B6B', '#FF8E53', '#FFD93D', '#6BCB77'],
  ['#4D96FF', '#6A4C93', '#B983FF', '#FF6F91'],
  ['#00C9A7', '#00B8D9', '#845EC2', '#F9F871'],
  ['#2C73D2', '#0081CF', '#C34A36', '#FF9671'],
];
